import React, { useState, useRef, useEffect } from "react";
import { RxHamburgerMenu } from "react-icons/rx";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { AiOutlineHome, AiOutlineDollar } from "react-icons/ai";
import { FaBullhorn, FaFileAlt, FaPencilRuler } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import logo from "../assets/resume/logo.png";
import { useMediaQuery } from "react-responsive";
import { useSelector, useDispatch } from "react-redux";
import { loginModal } from "../Redux/authAction";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Goo from "../assets/icons/Picture1.png";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import { auth } from "../FirebaseConfig";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "clamp(90%, 400px, 100%)",
  maxWidth: "500px",
  height: "auto",
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  p: 4,
};

const SidebarHeader = () => {
  const isMobile = useMediaQuery({
    query: "(max-width: 600px)",
  });

  const [state, setState] = useState(false);
  const [isLogin, setIsLogin] = useState(true); // State to toggle between login and signup
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const sidebarRef = useRef(null);

  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );

  const loginModalValue = useSelector((state) => state.authReducer.loginModal);

  const dispatch = useDispatch();

  const handleOpen = () => {
    dispatch(loginModal(true));
  };

  const handleClose = () => {
    dispatch(loginModal(false));
  };

  const toggleSidebar = () => {
    setState((prevState) => !prevState);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarOpen(false);
  };

  const handleLogin = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      setSnackbarSeverity("success");
      setSnackbarMessage("Login successful!");
      setSnackbarOpen(true);
      dispatch(loginModal(false));
    } catch (error) {
      setSnackbarSeverity("error");
      setSnackbarMessage("Failed to login. Please check your credentials.");
      setSnackbarOpen(true);
    }
  };

  const handleSignup = async () => {
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      await userCredential.user.updateProfile({
        displayName: displayName,
      });
      setSnackbarSeverity("success");
      setSnackbarMessage("Signup successful!");
      setSnackbarOpen(true);
      dispatch(loginModal(false));
    } catch (error) {
      setSnackbarSeverity("error");
      setSnackbarMessage("Failed to sign up. Please try again.");
      setSnackbarOpen(true);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      setSnackbarSeverity("success");
      setSnackbarMessage("Login successful!");
      setSnackbarOpen(true);
      dispatch(loginModal(false));
    } catch (error) {
      setSnackbarSeverity("error");
      setSnackbarMessage("Failed to login with Google. Please try again.");
      setSnackbarOpen(true);
    }
  };

  // Close sidebar when clicking outside of it
  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setState(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarRef]);

  return (
    <div>
      {/* Header Section */}
      <div className="h-16 shadow-md flex items-center px-4 w-full bg-white text-black fixed top-0 left-0 z-50">
        <div className="flex justify-between w-full items-center">
          <div className="flex gap-4 items-center">
            <RxHamburgerMenu
              onClick={toggleSidebar}
              className="text-[28px] cursor-pointer"
            />
            <img
              src={logo}
              className="cursor-pointer w-[150px] h-auto"
              alt="Logo"
            />
          </div>
          <div className="flex gap-4">
            {!isAuthenticated && (
              <button
                onClick={handleOpen}
                className="bg-[#FF5454] text-white px-4 py-1 rounded-md text-[14px] font-semibold"
              >
                Log In
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Sidebar Section */}
      <div
        ref={sidebarRef}
        className={`fixed top-0 left-0 bg-white h-full transition-all z-40 shadow-lg ${
          state ? "w-[250px]" : "w-0"
        } overflow-hidden`}
      >
        <div className="relative h-full flex flex-col justify-between">
          <div className="flex flex-col gap-1 pt-20">
            <NavLink
              to="/"
              className="hover:bg-gray-100 py-2 pl-4 flex items-center gap-3"
              onClick={toggleSidebar}
            >
              <AiOutlineHome className="text-[20px] text-[#323232]" />
              <p className="font-medium text-[15px] text-[#323232]">Home</p>
            </NavLink>
            <NavLink
              to="/category/design/Promotion Maker"
              className="hover:bg-gray-100 py-2 pl-4 flex items-center gap-3"
              onClick={toggleSidebar}
            >
              <FaBullhorn className="text-[20px] text-[#323232]" />
              <p className="font-medium text-[15px] text-[#323232]">
                Promotion Maker
              </p>
            </NavLink>
            <NavLink
              to="/category/design/Resume Maker"
              className="hover:bg-gray-100 py-2 pl-4 flex items-center gap-3"
              onClick={toggleSidebar}
            >
              <FaFileAlt className="text-[20px] text-[#323232]" />
              <p className="font-medium text-[15px] text-[#323232]">
                Resume Maker
              </p>
            </NavLink>
            <NavLink
              to="/category/design/Logo Maker"
              className="hover:bg-gray-100 py-2 pl-4 flex items-center gap-3"
              onClick={toggleSidebar}
            >
              <FaPencilRuler className="text-[20px] text-[#323232]" />
              <p className="font-medium text-[15px] text-[#323232]">Logo Maker</p>
            </NavLink>
            <NavLink
              to="/price"
              className="hover:bg-gray-100 py-2 pl-4 flex items-center gap-3"
              onClick={toggleSidebar}
            >
              <AiOutlineDollar className="text-[20px] text-[#323232]" />
              <p className="font-medium text-[15px] text-[#323232]">Pricing</p>
            </NavLink>
          </div>
          {!isAuthenticated && (
            <div className="mb-4">
              <NavLink
                to="#"
                onClick={() => {
                  handleOpen();
                  setIsLogin(false);
                }}
                className="hover:no-underline"
              >
                <div className="bg-[#FF5454] rounded-md w-[90%] m-auto text-center py-2">
                  <p className="font-semibold text-[14px] text-white">Sign Up</p>
                </div>
              </NavLink>
              <NavLink
                to="#"
                onClick={() => {
                  handleOpen();
                  setIsLogin(true);
                }}
                className="hover:no-underline"
              >
                <div className="bg-[#f0efef] rounded-md w-[90%] m-auto text-center py-2 mt-2">
                  <p className="font-semibold text-[14px] text-[#323232]">Log In</p>
                </div>
              </NavLink>
            </div>
          )}
        </div>

        {/* Close Sidebar Button */}
        <div
          onClick={toggleSidebar}
          className="absolute top-1/2 -right-6 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md cursor-pointer"
        >
          <MdKeyboardArrowLeft className="text-[24px] text-[#252627]" />
        </div>
      </div>

      {/* Login/Signup Modal */}
      <Modal
        open={isAuthenticated ? false : loginModalValue}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="rounded-lg text-[#262b33]">
          <div className="flex items-end justify-end" onClick={handleClose}>
            <p
              className="text-black p-1 text-lgs font-semibold hover:text-red-700"
              style={{ fontFamily: "poppins", fontSize: "16px" }}
            >
              X
            </p>
          </div>
          <div className="flex flex-col items-center">
            <p
              className="mb-4 text-[24px] font-[700]"
              style={{ fontFamily: "poppins" }}
            >
              {isLogin ? "Sign In" : "Sign Up"}
            </p>
            {!isLogin && (
              <input
                type="text"
                placeholder="Display Name"
                className="p-2 border-2 rounded w-full mb-4"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
              />
            )}
            <input
              type="text"
              placeholder="Email"
              className="p-2 border-2 rounded w-full mb-4"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              className="p-2 border-2 rounded w-full mb-4"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              onClick={isLogin ? handleLogin : handleSignup}
              className="bg-gradient-to-r from-[#4c76cf] to-[#552ab8] px-7 py-3 rounded-md text-white text-[16px] font-[600] cursor-pointer w-full"
            >
              {isLogin ? "Login" : "Sign Up"}
            </button>
            <div className="flex justify-between w-full mt-2">
              {isLogin && (
                <NavLink to="/forgot-password" className="text-[#4c76cf]">
                  Forgot Password?
                </NavLink>
              )}
            </div>
            <div className="flex flex-col items-center mt-4">
              <button
                onClick={handleGoogleLogin}
                className="flex items-center bg-white border border-gray-300 rounded-lg shadow-md px-6 py-2 text-sm font-medium text-gray-800 hover:bg-gray-200 w-full justify-center"
              >
                <img src={Goo} className="h-6 mr-2" alt="Google logo" />
                Continue with Google
              </button>
            </div>
            <div className="mt-4">
              <p>
                {isLogin
                  ? "Don't have an account?"
                  : "Already have an account?"}{" "}
                <span
                  onClick={() => setIsLogin(!isLogin)}
                  className="text-[#4c76cf] cursor-pointer font-semibold"
                >
                  {isLogin ? "Sign Up" : "Log In"}
                </span>
              </p>
            </div>
          </div>
        </Box>
      </Modal>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default SidebarHeader;
